import React, { useEffect } from 'react'

const AppDownload = () => {
  async function redirectToAppDownloadLink() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (userAgent) {
      if (/android/i.test(userAgent)) {
        window.location.replace(`https://play.google.com/store/apps/details?id=com.rolzo.partner&hl=en_US&gl=US`)
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.replace(`https://apps.apple.com/ae/app/rolzo-partner/id1612210928`)
      } else {
        window.location.replace(`https://partners.rolzo.com`)
      }
    }
  }

  useEffect(() => {
    redirectToAppDownloadLink()
  }, [])

  return (
    <div> </div>
  )
}

export default AppDownload